import IconQilu from '@/images/h5-common/logo.webp';
import React from 'react';

// 定义Props接口
interface DownloadAppBannerProps {
  alignBottom?: boolean;
  maxWidthClassName?: string;
  outerPaddingClassName?: string;
}

function DowloadAppBanner({
  alignBottom = true,
  maxWidthClassName = 'max-w-[800px]',
  outerPaddingClassName = '',
}: DownloadAppBannerProps) {
  return (
    <div className='fixed top-0 bottom-0 right-0 left-0 pointer-events-none z-[1000]'>
      <div className='relative w-full h-full'>
        <div className={`absolute ${alignBottom?'bottom-0 ':'top-0'} left-0 right-0 pointer-events-auto`}>
          <div className={`flex w-full justify-center bg-white ${outerPaddingClassName}`.trim()}>
            <div className={`flex flex-row h-[80px] w-full ${maxWidthClassName} items-center justify-between pl-[16px] pr-[16px]`.trim()}>
              <div className='flex flex-row items-center'>
                <img src={IconQilu} alt='' className='w-[55px] h-[55px]'/>
                <div className='flex flex-col ml-[10px]'>
                  <div className='text-[#313131] text-[14px] font-semibold whitespace-nowrap mb-[3px]'>
                    天才鸭
                  </div>
                  <div className='text-[#666666] text-[13px] font-normal whitespace-nowrap'>
                    英语学习好帮手
                  </div>
                </div>
              </div>
              <div
                  onClick={() => (window.location.href = 'https://sduck.net')}
                  className='w-[80px] h-[35px] rounded-full bg-[#FFAA1B] flex items-center justify-center text-[#FFFFFF]'>
                下载App
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DowloadAppBanner;
